import React from 'react';
import PropType from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import TooltipSideBar from './TooltipSideBar/TooltipSideBar';
import { RightOutlined } from '@ant-design/icons';
import noop from 'lodash/noop';

import ExpansionPanel from 'zignal-landscape/lib/ExpansionPanel';
import ExpansionPanelBody from 'zignal-landscape/lib/ExpansionPanelBody';
import ExpansionPanelTitle from 'zignal-landscape/lib/ExpansionPanelTitle';

// Render all current filters. This should be replaced
// with fetched data and
// each filter custom component once with create them.
const currentList = [
  {
    title: 'KEYWORDS',
    tooltip: `Filter results by individual keywords or short phrases. Selecting "Any" shows mentions 
    containing any number of the included keywords, while "All" 
    shows mentions containing every single keyword. 
    Choose "Advanced" to exclude any keywords.`
  },
  {
    title: 'DATASETS',
    tooltip: 'Filter results by one or multiple Datasets.'
  },
  {
    title: 'SOURCE',
    tooltip: 'Filter results by Source type. e.g. if you only want to view Tweets, select Twitter.'
  },
  {
    title: 'ENTITIES',
    tooltip: `Filter results by individual entities or short phrases. Selecting "Any" 
    shows mentions containing any number of the included entities, while "All" 
    shows mentions containing every single entity. Choose "Show Exclusion" to exclude any entities.`
  },
  {
    title: 'PRESS RELEASE',
    tooltip: 'Filter based on Press Release.'
  },
  {
    title: 'LOCATION',
    tooltip: 'Filter results based on states/regions, and/or countries.'
  },
  {
    title: 'LANGUAGE',
    tooltip: 'Filter results based on one or more chosen languages'
  },
  {
    title: 'CONTENT',
    tooltip: 'Filter results based on links, photos, or videos they contain.'
  },
  {
    title: 'SENTIMENT',
    tooltip: 'Filter results based on stories with a Positive, Negative, or Neutral sentiment.'
  },
  {
    title: 'INFLUENCE',
    tooltip: `Filter results based on influence ranging from high to unknown. 
    This is helpful for viewing stories from influential authors and sites.`
  },
  {
    title: 'GENDER',
    tooltip: 'Filter results based on Gender of the author.'
  },
  {
    title: 'MEDIA OUTLETS',
    tooltip: 'Filter results based on Media Outlet name, Facebook Page name, Subreddit name or Telegram channel name.',
  },
  {
    title: 'DOMAIN',
    tooltip: `Filter results based on domain(s). "Link" filters by the domain of a shared link. 
    "Source" filters by the domain where the story came from.`
  },
  {
    title: 'AUTHOR',
    tooltip: `Filter results based on author(s) name. "From" filters the stories by the author name. 
    "Original" filters the stories which are quotes, comments or replies TO that author.`
  },
  {
    title: 'SOURCE RELIABILITY',
    tooltip: `Filter results based on the likelihood that an author is automated. 
    The higher the value, the more likely the author is exhibiting automated behaviors.`
  }
];

const FilterSideBar = ({
  styles,
  onChangeCallBack = noop
}) => {
  const [openPanels, setOpenPanels] = React.useState([0, 1, 2]);

  const handlePanelToggle = (index) => {
    setOpenPanels(prev => {
      const isOpen = prev.includes(index);
      if (isOpen) {
        return prev.filter(i => i !== index);
      }
      return [...prev, index];

    });
    onChangeCallBack();
  };

  return (
    <div className={styles.CollapseHeader}>
      {currentList.map((item, index) => {
        const isOpen = openPanels.includes(index);
        const tooltip = <TooltipSideBar item={item} />;
        return (
          <ExpansionPanel key={index} onClick={() => handlePanelToggle(index)}>
            <ExpansionPanelTitle isOpen={isOpen}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                {tooltip}
                <RightOutlined
                  rotate={isOpen ? 90 : 0}
                  style={{fontSize: '1rem', fontWeight: '900' }}
                />
              </div>
            </ExpansionPanelTitle>
            <ExpansionPanelBody isOpen={isOpen}>
              <p>
                {item.content || 'Placeholder content'}
              </p>
            </ExpansionPanelBody>
          </ExpansionPanel>
        );
      })}
    </div>
  );
};

FilterSideBar.propTypes = {
  styles: PropType.object.isRequired,
  onChangeCallBack: PropType.func,
};

export default themeable(FilterSideBar);

